import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
    name: 'lastCheckReadable',
})
export class LastCheckReadablePipe implements PipeTransform {
    constructor(private datePipe: DatePipe) {
    }

    transform(lastUpdate: Date) {
        const timeDiff = ((new Date().getTime() - new Date(lastUpdate).getTime()) / 1000) / 60;
        // in minutes
        if (timeDiff < 90) {
            let minuteText = 'minuut geleden'
            if (Math.round(timeDiff) > 1 || Math.round(timeDiff) === 0) {
                minuteText = 'minuten geleden'
            }
            return `${Math.round(timeDiff)} ${minuteText}`
        }

        const hourTimeDiff = timeDiff / 24;
        // in hours
        if (hourTimeDiff < 24) {
            let hourText = 'uur geleden'
            return `${Math.round(hourTimeDiff)} ${hourText}`

        }
        return this.datePipe.transform(lastUpdate, 'EEE d MMM yyyy HH:mm:ss');
    }
}
